import { render, staticRenderFns } from "./DatePickerComponentFlat.vue?vue&type=template&id=c183d8c8&scoped=true&"
import script from "./DatePickerComponentFlat.vue?vue&type=script&lang=js&"
export * from "./DatePickerComponentFlat.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerComponentFlat.vue?vue&type=style&index=0&id=c183d8c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c183d8c8",
  null
  
)

export default component.exports